/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Providers_ColumnInputs */

const en_endpoint_providers_column = /** @type {(inputs: Endpoint_Providers_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Providers`)
};

const zh_hans1_endpoint_providers_column = /** @type {(inputs: Endpoint_Providers_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务商`)
};

const pt_br2_endpoint_providers_column = /** @type {(inputs: Endpoint_Providers_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provedores`)
};

const es_endpoint_providers_column = /** @type {(inputs: Endpoint_Providers_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedores`)
};

const fr_endpoint_providers_column = /** @type {(inputs: Endpoint_Providers_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseurs`)
};

const de_endpoint_providers_column = /** @type {(inputs: Endpoint_Providers_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieter`)
};

const ru_endpoint_providers_column = /** @type {(inputs: Endpoint_Providers_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщики`)
};

const it_endpoint_providers_column = /** @type {(inputs: Endpoint_Providers_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Providers" |
*
* @param {Endpoint_Providers_ColumnInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_providers_column = /** @type {((inputs?: Endpoint_Providers_ColumnInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Providers_ColumnInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_providers_column(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_providers_column(inputs)
	if (locale === "es") return es_endpoint_providers_column(inputs)
	if (locale === "fr") return fr_endpoint_providers_column(inputs)
	if (locale === "de") return de_endpoint_providers_column(inputs)
	if (locale === "ru") return ru_endpoint_providers_column(inputs)
	if (locale === "it") return it_endpoint_providers_column(inputs)
	return en_endpoint_providers_column(inputs)
});